<template>
  <div>
    <page-header
      :actions="pageActionConfig"
      class="page-header__extended"
      :page="pageConfig"
    />
    <filter-manager
      v-model="filters"
      class="rounded"
      :display-advanced="false"
      :filters="filtersConfig"
      search-container-class="align-self-end"
      @dateFrom="filters.dateTo = null"
      @search="onSearchHandler(1)"
    />
    <custom-separator class="my-4" text="Resultado de Solicitudessss" />
    <custom-result-not-found v-if="itemList.length == 0" />
    <template v-else>
      <div v-for="(item, index) in itemList" :key="`case-row-${index}`">
        <case-row
          class="mb-3"
          :download-document="downloadDocument"
          :get-case-documents="getCaseDocuments"
          :get-comment-history="getCommentHistory"
          :value="item"
          @on-add-comment="openCallout($event, item)"
          @on-cancel="onCancelAddCommentHandler(item)"
          @on-delete="onDeletehandler(item)"
          @on-download-document="onOnDownloadDocumentHandler"
          @on-open="onOpenHandler(item)"
          @on-save-additional-info="onSaveAdditionalInfoHandler"
        />
      </div>
      <pagination
        v-if="pagination.totalItemCount > defaultPageSize"
        :data="pagination"
        show-text
        @pagination-go-page="goToPageHandler"
      />
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import Pagination from 'pagination';
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import CaseRow from './components/SearchResult.vue';
import alertMixin from 'utils/mixins/alert.mixin.js';
import serialize from 'object-to-formdata';

const TICKET_CREATION_DEFAULT_ROUTE_NAME = 'CreateTicket';

export default {
  name: 'TicketSearch',
  mixins: [alertMixin],
  components: {
    CustomResultNotFound,
    CustomSeparator,
    FilterManager,
    PageHeader,
    Pagination,
    CaseRow,
  },
  props: {
    defaultPageSize: {
      type: Number,
      default: () => 20,
    },
    downloadDocument: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getUserCases: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getCommentHistory: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getStatus: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    deleteCase: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getUserCase: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    getCaseDocuments: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    saveAdditionalInfo: {
      type: Function,
      default: () => Promise.resolve({}),
    },
    ticketCreationRoute: {
      type: String,
      default: () => TICKET_CREATION_DEFAULT_ROUTE_NAME,
    },
    statusId: {
      type: Number,
      default: () => null,
    },
    hasBackAction: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    pagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: 0,
    },
    itemList: [],
    filters: {},
    filterOptions: {
      status: [],
    },
  }),
  computed: {
    pageConfig() {
      return {
        icon: 'fas fa-user-headset',
        title: 'Mesa de Apoyo',
        routes: [],
      };
    },
    pageActionConfig() {
      let actions = [];
      if (this.hasBackAction) {
        actions.push({
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left fa-fw',
          variant: 'outline-success',
          click: () => this.$router.push('/'),
        });
      }
      if (this.userHasPermissions('rempro.helpdesk.createrequestbutton')) {
        actions.push({
          text: 'Crear Solicitud',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: () => this.$router.push({ name: this.ticketCreationRoute }),
        });
      }
      return actions;
    },
    filtersConfig() {
      return [
        {
          name: 'dateFrom',
          label: 'Fecha Desde:',
          component: 'CustomDatePicker',
          placeholder: 'DD/MM/YYYY',
          classContainer: 'w-100',
          class: 'col-12 col-md-3',
          maxDate: new Date(),
        },
        {
          name: 'dateTo',
          label: 'Fecha Hasta:',
          component: 'CustomDatePicker',
          placeholder: 'DD/MM/YYYY',
          classContainer: 'w-100',
          class: 'col-12 col-md-3',
          minDate: this.filters.dateFrom
            ? moment(this.filters.dateFrom)
                .add(-1, 'days')
                .toDate()
            : null,
          maxDate: moment(new Date()).toDate(),
        },
        {
          name: 'status',
          label: 'Estatus:',
          component: 'CustomDropDown',
          options: this.filterOptions.status,
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-12 col-md-3',
        },
        {
          name: 'caseNumber',
          label: 'Número de Caso:',
          component: 'CustomInput',
          placeholder: 'Escriba Número de Caso',
          class: 'col-12 col-md-3',
        },
      ];
    },
  },
  async created() {
    await this.initOptions().then(() => {
      this.onSearchHandler(1);
    });
  },
  methods: {
    async goToPageHandler(page) {
      await this.onSearchHandler(page);
    },
    async initOptions() {
      const { data } = await this.getStatus();
      this.filterOptions.status = data;
      if (this.statusId) {
        var status = this.filterOptions.status.find(
          (x) => x.id == this.statusId
        );
        this.filters.status = status;
      }
    },
    async onSearchHandler(page) {
      this.pagination.currentPage = page;
      const model = { ...this.filters };

      const params = {
        dateFrom: model.dateFrom,
        dateTo: model.dateTo,
        statusId: model.status?.id,
        caseNumber: model.caseNumber,
      };
      const { data: res } = await this.getUserCases(
        params,
        this.pagination.currentPage,
        this.defaultPageSize
      );
      this.itemList = [...res.data];
      this.pagination = {
        currentPage: res.currentPage,
        count: res.count,
        pageCount: res.pageCount,
        totalItemCount: res.totalItemCount,
      };
    },
    openCallout(mode, item) {
      this.itemList = this.itemList.map((x) => {
        const isOpen = x.id === item.id;
        return {
          ...x,
          isOpen,
          mode: isOpen ? mode : null,
        };
      });
    },
    async onDeletehandler(item) {
      const answer = await this.ShowCancelModal(
        'Atención',
        `¿Está seguro que desea eliminar la solicitud ${item.caseNumber}?`,
        'Sí',
        'No'
      );
      if (!answer) return;

      await this.deleteCase(item.id)
        .then(async () => {
          await this.onSearchHandler(1);
          this.ShowToast(
            'Proceso exitoso',
            'La solicitud ha sido eliminada exitosamente.',
            'success'
          );
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
    onOpenHandler(item) {
      this.$emit('on-open-case', item);
    },
    onCancelAddCommentHandler(item) {
      const item_ = this.itemList.find((x) => x.id == item.id);
      item_.isOpen = false;
    },
    async onOnDownloadDocumentHandler(data) {
      this.downloadDocument(data);
    },
    async onSaveAdditionalInfoHandler(dto) {
      const formData = serialize(dto, { indices: true });

      if (dto.document && dto.document.data) {
        formData.append(`file`, dto.document.data);
      }

      await this.saveAdditionalInfo(formData)
        .then(async () => {
          const item_ = this.itemList.find((x) => x.id == dto.itemId);

          item_.isOpen = false;

          this.ShowToast(
            'Proceso exitoso',
            'La información ha sido guardada exitosamente.',
            'success'
          );

          await this.onSearchHandler(this.pagination.currentPage);
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .page-header__extended {
  .nav-text {
    display: none;
  }
}
</style>
